<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex">
      <!-- LOGO: the licence's own logo when it has one (implementation-plan-licence-logo-2026-10.md), else
           Evide's. A custom logo sits in a fixed 40px-high, 200px-wide box so any shape fits without moving the menu. -->
      <div class="navbar-brand-box">
        <a routerLink="/" class="logo logo-dark">
          <span class="logo-sm">
            <img [src]="brandLogo('logo')" alt="" height="25" [class.licence-logo]="hasLicenceLogo">
          </span>
          <span class="logo-lg">
            <img [src]="brandLogo('logo-dark')" alt="" height="25" [class.licence-logo]="hasLicenceLogo">
          </span>
        </a>

        <a routerLink="/" class="logo logo-light">
          <span class="logo-sm">
            <img [src]="brandLogo('logo-light-small')" alt="" height="25" [class.licence-logo]="hasLicenceLogo">
          </span>
          <span class="logo-lg">
            <img [src]="brandLogo('logo-light')" alt="" height="25" [class.licence-logo]="hasLicenceLogo">
          </span>
        </a>
      </div>

      <button type="button" class="btn btn-sm px-3 font-size-16 header-item" id="vertical-menu-btn"
        (click)="toggleMobileMenu($event)">
        <i class="fa fa-fw fa-bars"></i>
      </button>
      <ng-container *ngIf="user">
        <!-- Licence switcher: only users who can change licence (System Admin). -->
        <ng-container *accessVisibility="{
        controllerKey: Access.Authentication, methodKey: AccessMethodKey.ChangeLicense
       }">
          <app-menu-license-list></app-menu-license-list>
        </ng-container>
        <!-- Project switcher: any user with more than one assigned project (its own *ngIf gates display). -->
        <app-menu-project-license-list></app-menu-project-license-list>
      </ng-container>

    </div>

    <div class="d-flex align-items-center">


      <!-- Support email icon -->
      <div class="mx-2">
        <a href="mailto:support@evide.org.uk" class="text-white">
          support&#64;evide.org.uk
        </a>
      </div>

      <!-- Support phone icon -->
      <div class="mx-2">
        <a href="tel:+44(0)2871225395" class="text-white">
          +44 (0) 2871 225 395
        </a>
      </div>

      <div class="dropdown d-none d-lg-inline-block mx-1">
        <button type="button" class="btn header-item noti-icon" data-toggle="fullscreen" (click)="fullscreen()">
          <i class="bx bx-fullscreen"></i>
        </button>
      </div>

      <app-notification-bell *ngIf="user"></app-notification-bell>

      <div class="dropdown d-inline-block" dropdown *ngIf="user">
        <button type="button" class="btn header-item" dropdownToggle id="page-header-user-dropdown">
          <img class="rounded-circle header-profile-user" [alt]="user.username"
            [src]="imageUrl || ''">
          <span class="d-none d-xl-inline-block ms-1">
            {{user.fullName}}
          </span>
          <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-end" *dropdownMenu>
          <!-- item-->
          <dropdown-item routerLink="/profile" iconClass="bx bx-user font-size-16 align-middle me-1">
            {{ 'HEADER.LOGIN.PROFILE' | translate}}
          </dropdown-item>
          <a class="dropdown-item" href="javascript: void(0);" (click)="changePassword()"><i
              class="bx bx-lock-open-alt font-size-16 align-middle me-1"></i>
            {{ 'HEADER.LOGIN.CHANGE_PASSWORD' | translate}}</a>

          <div class="dropdown-divider"></div>
          <a class="dropdown-item text-danger" href="javascript: void(0);" (click)="logout()"><i
              class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>
            {{ 'HEADER.LOGIN.LOGOUT' | translate}}</a>
        </div>
      </div>

    </div>
  </div>
</header>